<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/KMzmv/tc-custom/9780253027191.jpg?1709153587229" alt="This image is the cover for the book Essential Israel, Perspectives on Israel Studies"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Essential Israel, Perspectives on Israel Studies
      </h1>
      <p class="bookDescription body article font2">
        <b>“An excellent tool in Middle Eastern politics classes [and] an intellectual resource for experts who want to learn more about the complexities of Israel.”—<i>Reading Religion</i></b><br/><br/> Americans debate constantly about Israel, its place in the Middle East, and its relations with the United States. <i>Essential Israel</i> examines a wide variety of complex issues and current concerns in historical and contemporary contexts to provide readers with an intimate sense of the dynamic society and culture that is Israel today, providing a broader and deeper understanding to inform the conversation.<br/>  <br/> The expert contributors to this volume address the Arab-Israeli conflict, the state of diplomatic efforts to bring about peace, Zionism and the impact of the Holocaust, the status of the Jewish state and Israeli democracy, foreign relations, immigration and Israeli identity, as well as literature, film, and the other arts. This unique and innovative volume provides solid grounding to understandings of Israel’s history, politics, culture, and possibilities for the future.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        S. Ilan Troen, Rachel Fish, Arnon Golan, Maoz Azaryahu, Michael Brenner, Alan Dowty, David Makovsky, Gil Troy, Yedidia Stern, Donna Robinson Divine, Steven Bayme, David Ellenson, Yaakov Ariel, Norman Stillman, Rachel S. Harris, Ranen Omer-Sherman, Carol Troen
      </h2>
      
      <p class="authorDescription body article">Rachel Fish is Associate Director of the Schusterman Center.S. Ilan Troen is the Karl, Harry, and Helen Stoll Chair in Israel Studies and founding Director of the Schusterman Center for Israel Studies at Brandeis University. He is founding editor of Israel Studies. His publications include Imagining Zion: Dreams, Designs and Realities in a Century of Jewish Settlement and (with Jacob Lassner) Jews and Muslims in the Arab World: Haunted by Pasts Real and Imagined.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?184c2a4e